<!--Creates card type form label right-->
<template>
    <div>
        <v-container v-if="card.type == 'FormLabelRight'" fluid grid-list-md>
            <v-data-iterator v-if="renderTable" :items="formData"
                             :pagination.sync="pagination"
                             :rows-per-page-items="pagination.rowsPerPageItems"
                             content-tag="v-layout"
                             row
                             wrap>

                <!--Ajax error.-->
                <template v-slot:no-data>
                    <v-flex>
                        <v-card>
                            <div class="form-label-action">
                                <v-icon v-if="permissions.indexOf('A') != -1 && card.type == 'FormLabelRight'" @click="add" small class="mr-2 vue-marterial-icon vue-marterial-add-icon" :title="$t('Add')"> add </v-icon>
                            </div>
                            <div class="text-xs-center" style="width: 100%;">No data available</div>
                        </v-card>
                    </v-flex>
                </template>

                <template v-slot:item="props">
                    <v-flex>
                        <v-card>
                            <div class="form-label-action">
                                <v-icon v-if="permissions.indexOf('A') != -1 && card.type == 'FormLabelRight'" @click="add" small class="mr-2 vue-marterial-icon vue-marterial-add-icon" :title="$t('Add')"> add </v-icon>
                                <v-icon v-if="permissions.indexOf('E') != -1 && card.type == 'FormLabelRight'" @click="editItem(props.item)" small class="mr-2 vue-marterial-icon vue-marterial-edit-icon" :title="$t('Edit')"> edit </v-icon>
                                <v-icon v-if="permissions.indexOf('D') != -1 && card.type == 'FormLabelRight'" @click="deleteItem(props.item)" small class="mr-2 vue-marterial-icon vue-marterial-delete-icon" :title="$t('Delete')"> delete </v-icon>
                            </div>
                            <v-list dense v-for="field in fields" v-if="!field.primaryKey && !field.parent && field.list != false && field.type != 'Hidden'">
                                <v-list-tile v-for="(val,i) in props.item" v-if="i == field.value">
                                    <v-list-tile-content class="align-end form-label-right">{{val}}</v-list-tile-content>
                                    <v-list-tile-content class="label form-label-right">{{field.title}}</v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-card>
                    </v-flex>
                </template>
            </v-data-iterator>
        </v-container>
    </div>
</template>

<script>
    /*
        * Method for pupulate card type form label right control - STARTS
    */
    export default {
        /*
            *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        */
        data() {
            return this.$store.state[this.$options.parent.fileName];
        },

        /**
            * Methods
        */
        methods: {
        }
    }
</script>
